<template>
  <div class="foot">
    <div class="box left">
      
      <div class="left_content">
         <span><a id="ICP" href="http://beian.miit.gov.cn">粤ICP备 2024330399号-1</a></span>
        <span>深圳市意达五金制品有限公司</span>
        <span>Copyright © 2024 Edapt All Rights Reserved</span>
      </div>
    </div>
    <!-- 右边的信息栏目 -->
    <div class="box right">
      <h1>联系我们</h1>
      <Contact></Contact>
    </div>
  </div>
</template>

<script>
import Contact from './Contact.vue';
export default {
  components:{
    Contact,
  }
}
</script>

<style scoped lang="less">
.left{
  text-align: center;
}
.left_content{
  span, a {
    color: #ccc;
    font-weight: 400;
    font-size: 16px;
    text-decoration: none; // 去掉链接下划线
  }
  // 鼠标悬浮时也保持一致（可选，如需hover效果可自定义）
  a:hover {
    color: #fff; // 保持颜色不变
    text-decoration: none; // 保持无下划线
    background-color: transparent; // 背景透明
  }
  margin-top: 200px;
  margin-left: 10vw;
  display: grid;
  column-gap: 20px;
  row-gap: 10px;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.foot{
    width: 100%;
    min-width:1500px;
    height: 100%;
    background: rgb(23, 38, 59); 
    // background: linear-gradient(to bottom, #777, #555);
    display: flex;
}
.box{
  flex:1;
}
.right{
  margin: 40px 80px;
  border: 2px solid #fff;
}
.right h1{
  padding: 10px 13px;
  letter-spacing:3px;
  color: #fff;
  font-weight: 400;
  font-size: 21px;
}
.ICP a{
  /* 文字颜色继承父元素 */
  color: #ccc;
  /* 鼠标悬浮时背景透明 */
  background-color: transparent;
}
</style>